import { PartialPartner } from "@/common/partner/types";

// Whitelist of partner UUIDs that should display full names instead of keys
const PARTNER_FULL_NAME_WHITELIST = ["8f9e16c2-cb0d-4e37-999a-4e7090ea9b69"];

export const getPartnerDisplayName = (
  partnerUUID: string,
  partnerKey: string,
  partnerFullName: string,
): string => {
  if (PARTNER_FULL_NAME_WHITELIST.includes(partnerUUID)) {
    return partnerFullName;
  }
  return partnerKey;
};

export const getPartnersDisplayNames = (partners: PartialPartner[]): string => {
  if (partners.length === 0) return "";
  return partners
    .map((partner) =>
      getPartnerDisplayName(partner.uuid, partner.key, partner.name),
    )
    .join(", ");
};

export const getSinglePartnerDisplayName = (
  partner: PartialPartner,
): string => {
  return getPartnerDisplayName(partner.uuid, partner.key, partner.name);
};
